import { INTENT_LABELS, INTENT_COLORS } from '../config/endoTaxonomy';

// Темы звонков «Эндо 360»: коды и подписи берём из единого справочника
// (src/config/endoTaxonomy.js — зеркало EndoTaxonomy.IntentLabels на бэке).
export const CALL_CLASSIFICATION_LABELS = INTENT_LABELS;

export const CALL_CLASSIFICATION_COLORS = INTENT_COLORS;

export const formatClassificationType = (value) => {
  if (!value) return 'Без темы';
  const key = String(value).trim().toLowerCase();
  if (!key) return 'Без темы';
  if (CALL_CLASSIFICATION_LABELS[key]) return CALL_CLASSIFICATION_LABELS[key];
  return key
    .split('_')
    .filter(Boolean)
    .map((part) => part[0].toUpperCase() + part.slice(1))
    .join(' ');
};

export const formatTopicLabel = (value, fallbackType) => {
  const normalized = String(value ?? '').trim();
  if (!normalized) {
    return formatClassificationType(fallbackType);
  }

  const normalizedLower = normalized.toLowerCase();
  if (normalizedLower === 'заказ/покупка с сайта') {
    return 'Покупка с сайта';
  }
  if (normalizedLower === 'существующая заявка/заказ') {
    return 'Существующая заявка';
  }
  if (normalizedLower === 'подтверждение заказа') {
    return 'Подтверждение покупки';
  }
  if (normalizedLower === 'заказ') {
    return 'Покупка';
  }
  if (normalizedLower === 'предзаказ') {
    return 'Предварительная покупка';
  }

  return normalized;
};
